import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import i18next from "i18next";

import translationEng from './../../Lanugage/en.json';
import translationTel from './../../Lanugage/te.json';

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'te', 'hin'],
    debug: false,
    fallbackLng: "en",
    detection: {
      order: ['cookie', 'path', 'htmlTag', 'localStorage'],
      caches: ['cookie']
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/assets/Language/{{lng}}.json`
    },
    resources: {
      en: {
        translations: translationEng
      },
      te: {
        translations: translationTel
      },
    },
    ns: ["translations"],
    defaultNS: "translations"
  });

// Log language and resources for debugging

export default i18next;
